import {
  applicationsPagePath,
  chainsPagePath,
  dataPagePath,
  modelApisPagePath,
  modelsPagePath,
  overviewPagePath,
  teamChainsPagePath,
  teamModelApisPagePath,
  teamModelsPagePath,
  teamSettingsPagePath,
  teamTrainingPagePath,
  trainingPagePath,
} from '@/routes/constants';
import { BasetenPageEnum, BasetenPageProps } from '@/routes/types';

const Routes: Array<BasetenPageProps> = [
  // workspace routes
  {
    page: BasetenPageEnum.Workspace,
    path: overviewPagePath,
  },
  {
    page: BasetenPageEnum.Workspace,
    path: modelApisPagePath,
  },
  {
    page: BasetenPageEnum.Workspace,
    path: chainsPagePath,
  },
  {
    page: BasetenPageEnum.Workspace,
    path: trainingPagePath,
  },
  {
    page: BasetenPageEnum.Workspace,
    path: applicationsPagePath,
  },
  {
    page: BasetenPageEnum.Workspace,
    path: dataPagePath,
  },
  {
    page: BasetenPageEnum.Workspace,
    path: modelsPagePath,
  },
  // new workspace routes
  {
    page: BasetenPageEnum.WorkspaceTeams,
    path: overviewPagePath,
  },
  {
    page: BasetenPageEnum.WorkspaceTeams,
    path: teamModelsPagePath,
  },
  {
    page: BasetenPageEnum.WorkspaceTeams,
    path: teamChainsPagePath,
  },
  {
    page: BasetenPageEnum.WorkspaceTeams,
    path: teamTrainingPagePath,
  },
  {
    page: BasetenPageEnum.WorkspaceTeams,
    path: teamModelApisPagePath,
  },
  {
    page: BasetenPageEnum.TeamSettings,
    path: teamSettingsPagePath,
  },
  {
    page: BasetenPageEnum.Settings,
    path: '/settings/:tabId?',
  },

  {
    page: BasetenPageEnum.DeployModel,
    path: '/deploy/:modelName',
  },
  {
    page: BasetenPageEnum.Model,
    path: '/models/:modelId/:tabId?/:tabEntityId?',
  },
  {
    page: BasetenPageEnum.Chain,
    path: '/chains/:chainId/:tabId?/:tabEntityId?/:chainletId?',
  },
  {
    page: BasetenPageEnum.CreateSharedEndpoint,
    path: '/model-apis/create',
  },
  {
    page: BasetenPageEnum.SharedEndpoint,
    path: '/model-apis/:sharedEndpointId/:tabId?',
  },
  {
    page: BasetenPageEnum.TrainingProject,
    path: '/training/:trainingProjectId/:tabId?/:trainingJobId?/:nodeId?',
  },
  {
    page: BasetenPageEnum.Onboarding,
    path: '/onboarding',
  },
  // Playground
  {
    page: BasetenPageEnum.Playground,
    path: '/playground/:modelFamily/:modelName?',
  },
];

export default Routes;
